import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import apiFetchManualPreadviceTransactionsDelete from '../../api/RfidFileDeleteAPI';
import { RFID_FILE_DELETE_REQUEST } from '../actions/types/RfidDeleteActionsTypes';
import { deleteRfidFileSuccessActionCreator, deleteRfidFileFailureActionCreator } from '../actions/RfidFileDeleteActions';
import { languageSelector } from '../../../../../common/redux/selectors/languageSelector';
import { showNotification } from '../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../locales/locales';

function* doRfidFileDeleteWorker(action) {
  const lang = yield select(languageSelector);

  try {
    const res = yield call(apiFetchManualPreadviceTransactionsDelete, action.payload);
    yield put(deleteRfidFileSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.rfidfile.delete.success'),
    }));
  } catch (error) {
    yield put(deleteRfidFileFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'notification.rfidfile.delete.failure'),
    }));
  }
}

function* doRfidFileDeleteWatcher() {
  yield takeLatest(RFID_FILE_DELETE_REQUEST, doRfidFileDeleteWorker);
}

export default doRfidFileDeleteWatcher;
